import './map.css';

export function Legend() {
  return (
    <div className="iris-legend">
      <div className="iris-legend-title">Status</div>
      <ul>
        <li>
          <span className="iris-legend-dot" style={{ background: '#4caf50' }} /> Operational
        </li>
        <li>
          <span className="iris-legend-dot" style={{ background: '#f5a623' }} /> Degraded
        </li>
        <li>
          <span className="iris-legend-dot" style={{ background: '#e53935' }} /> Offline / Critical
        </li>
        <li>
          <span className="iris-legend-dot" style={{ background: '#5b9bd5' }} /> Under construction
        </li>
        <li>
          <span className="iris-legend-dot" style={{ background: '#4a4f54' }} /> Decommissioned
        </li>
      </ul>
      <div className="iris-legend-title" style={{ marginTop: 6 }}>Marker size</div>
      <ul className="iris-legend-row">
        <li>
          <span className="iris-legend-dot" style={{ width: 6, height: 6, background: '#9ca3a9' }} /> 1-2
        </li>
        <li>
          <span className="iris-legend-dot" style={{ width: 8, height: 8, background: '#9ca3a9' }} /> 3
        </li>
        <li>
          <span className="iris-legend-dot" style={{ width: 10, height: 10, background: '#9ca3a9' }} /> 4
        </li>
        <li>
          <span className="iris-legend-dot" style={{ width: 12, height: 12, background: '#9ca3a9' }} /> 5
        </li>
      </ul>
      <div className="iris-legend-title" style={{ marginTop: 8 }}>Weather risk</div>
      <ul>
        <li>
          <span className="iris-legend-swatch" style={{ borderColor: '#5b9bd5', background: 'rgba(91, 155, 213, 0.14)' }} /> Marine icing / gale
        </li>
        <li>
          <span className="iris-legend-swatch" style={{ borderColor: '#f5a623', background: 'rgba(245, 166, 35, 0.14)' }} /> Wind curtailment
        </li>
        <li>
          <span className="iris-legend-swatch" style={{ borderColor: '#e53935', background: 'rgba(229, 57, 53, 0.16)' }} /> Convective storm
        </li>
      </ul>
      <div className="iris-legend-title" style={{ marginTop: 8 }}>Protection zones</div>
      <ul>
        <li>
          <span className="iris-legend-ring" style={{ borderColor: '#e0b96f' }} /> Critical perimeter
        </li>
        <li>
          <span className="iris-legend-ring" style={{ borderColor: '#5b9bd5' }} /> Subsea watch
        </li>
        <li>
          <span className="iris-legend-ring" style={{ borderColor: '#8fb0cc' }} /> Port restricted
        </li>
      </ul>
    </div>
  );
}
